import * as React from "react";

import { Button, Divider, Grid, Tab, Segment } from "semantic-ui-react";
import { Detail } from "@neworbit/simpleui-detail";

import { getYesNoOptionEnabledDisplayValue } from "@teamprevent/common/model";
import { readonlyCaseTypeOrgStructuresList } from "@teamprevent/common/customerUser/ReadonlyCaseTypeOrgStructures";

import { userRegistrationStatusText } from "@teamprevent/common/models/core";

import { CoreDetailProps, DetailProps } from "../Detail";
import DeleteButton from "../DeleteButton";
import { ADMIN_ROLES, Authorize } from "../../../../auth";

import { CoreDetailsButtons } from "./CoreDetailButtons";

import { Link } from "redux-little-router";

export const CoreDetails: React.FunctionComponent<CoreDetailProps> = (props) => (
    <Grid>
        <Detail label="Customer Id" value={props.customerUser.customerId} labelWidth={5} valueWidth={11} />
        <Detail label="Email Address" value={props.customerUser.emailAddress} labelWidth={5} valueWidth={11} />
        <Detail label="First Name" value={props.customerUser.firstName} labelWidth={5} valueWidth={11} />
        <Detail label="Surname" value={props.customerUser.surname} labelWidth={5} valueWidth={11} />
        <Detail label="Mobile Number" value={props.customerUser.mobileNumber} labelWidth={5} valueWidth={11} />
        <Detail label="Roles" value={props.customerUser.roles && props.customerUser.roles.join(", ")} labelWidth={5} valueWidth={11} />
        <Detail
            label="Lock Org Level 1 for Case Creation"
            value={getYesNoOptionEnabledDisplayValue(props.customerUser.lockOrgLevelOneForCaseCreation)}
            labelWidth={5}
            valueWidth={11} />
        <Detail label="Organisation Structure One" value={props.customerUser.orgStructureOne?.name} labelWidth={5} valueWidth={11} />
        <Detail label="Organisation Structure Two" value={props.customerUser.orgStructureTwo?.name} labelWidth={5} valueWidth={11} />
        <Detail label="Organisation Structure Three" value={props.customerUser.orgStructureThree?.name} labelWidth={5} valueWidth={11} />
        <Detail label="Organisation Structure Four" value={props.customerUser.orgStructureFour?.name} labelWidth={5} valueWidth={11} />
        <Detail
            label="View all cases for"
            value={readonlyCaseTypeOrgStructuresList(props.customerUser.caseTypeOrgStructures, props.orgStructures)}
            labelWidth={5}
            valueWidth={11}
        />
        <Detail label="Visible Generic Case Types" value={
            props.customerUser.genericCaseTypeViewPermissions &&
            props.customerUser.genericCaseTypeViewPermissions.map(g => g.name).join(", ")} labelWidth={5} valueWidth={11} />
        <Detail
            label="SRA Departments"
            value={props.customerUser.sraDepartmentNames && props.customerUser.sraDepartmentNames.join(", ")} labelWidth={5} valueWidth={11} />
        <Detail
            label="Multi Factor Authentication (MFA)"
            value={getYesNoOptionEnabledDisplayValue(props.customerUser.isMultiFactorAuthenticationEnabled)}
            labelWidth={5}
            valueWidth={11}
        />
        <Detail
            label="Active"
            value={props.customerUser.active !== null && props.customerUser.active !== undefined && props.customerUser.active.toString()}
            labelWidth={5}
            valueWidth={11}
        />
        <Detail label="Registration Status" value={userRegistrationStatusText[props.customerUser.registrationStatus]} labelWidth={5} valueWidth={11} />
        <Detail label="Registered Email Address" value={props.customerUser.registeredEmailAddress} labelWidth={5} valueWidth={11} />
    </Grid>
);

const CoreDetailsWithActions: React.FunctionComponent<DetailProps> = (props) => {
    return (
        <div>
            <CoreDetails customerUser={props.customerUser} orgStructures={props.orgStructures} />
            <Divider />
            <Segment basic clearing vertical>
                <Authorize roles={[ADMIN_ROLES.SENIOR_ADMINISTRATOR, ADMIN_ROLES.SYSTEM_ADMIN]}>
                    <DeleteButton />
                </Authorize>
                <Authorize roles={[ADMIN_ROLES.SENIOR_ADMINISTRATOR, ADMIN_ROLES.SYSTEM_ADMIN, ADMIN_ROLES.ADMINISTRATOR]}>
                    <CoreDetailsButtons customerUser={props.customerUser} orgStructures={props.orgStructures} />
                </Authorize>
                <Authorize roles={[ADMIN_ROLES.SENIOR_ADMINISTRATOR, ADMIN_ROLES.SYSTEM_ADMIN]}>
                    <Button icon="pencil" content="Edit" floated="right" as={Link} href={`${props.path}/edit`} />
                </Authorize>
            </Segment>
        </div>
    );
};

export const coreDetailsTab = (props: DetailProps) => ({
    path: "",
    menuItem: "Details",
    render: () => <Tab.Pane><CoreDetailsWithActions {...props} /></Tab.Pane>
});
